
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Dropdown, Menu, message, Modal } from 'antd';
import './style.css';

// Actions
import { save_designation, get_designation, delete_designation, get_designation_by_id, edit_designation } from './actions/designation.action';

// Childe Components
import NewDesignation from './childs/new.designation';
import EditDesignation from './childs/edit.designation';

const confirm = Modal.confirm;

class Designation extends Component {

    constructor( props ){
        super( props );

        this.state = {
            new_designation_modal: false,
            edit_designation_modal: false,
            company_id: '',
            data: [],
            edit_data: []
        }

        this.handleNewDesignation = this.handleNewDesignation.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleController = this.handleController.bind( this );
        this.handleSubmitEdit = this.handleSubmitEdit.bind (this );

    }

    handleController( e ){
        let self = this;

        if( e.key === '1' ){
            
            this.props.get_designation_by_id( e.item.props.id );

        } else if( e.key === '2' ){
            
            confirm({
                title: 'Do you Want to delete this Designation?',
                onOk() {
                    self.props.delete_designation( e.item.props.id );
                },
                onCancel() {
                    // Nothing
                },
            });

        }
    }

    handleNewDesignation(){
        this.setState({ new_designation_modal: true, edit_designation_modal: false });
    }

    handleSubmit( data ){

        this.props.save_designation( data );

        this.setState({
            new_designation_modal: false
        })

    }

    handleSubmitEdit( data ){

        this.props.edit_designation( data );

        this.setState({
            edit_designation_modal: false
        })

    }

    componentWillMount(){
        this.props.get_designation();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.designation.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        // Start

        if( nextProps.designation.STATUS.CODE === "200" && 
            nextProps.designation.STATUS.MESSAGE === "Successfully Saved Designation" ) {
            message.success('Successfully Saved Designation');
            this.props.get_designation();

            this.setState({
                new_designation_modal: false,
                edit_designation_modal: false,
            })

        } else if ( nextProps.designation.STATUS.CODE === "200" && 
            nextProps.designation.STATUS.MESSAGE === "Successfully Listed Designation" ) {
            this.setState({
                data: nextProps.designation.OUTPUT.DATA,
                new_designation_modal: false,
                edit_designation_modal: false,
            });

        } else if ( nextProps.designation.STATUS.CODE === "200" && 
            nextProps.designation.STATUS.MESSAGE === "Successfully Deleted Designation" ) {
            message.success('Successfully Deleted Designation');
            this.props.get_designation();
            this.setState({
                new_designation_modal: false,
                edit_designation_modal: false,
            })

        } else if ( nextProps.designation.STATUS.CODE === "200" && 
            nextProps.designation.STATUS.MESSAGE === "Successfully Listed By ID" ) {

            this.setState({
                edit_data: nextProps.designation.OUTPUT.DATA,
                edit_designation_modal: true,
                new_designation_modal: false
            });

        } else if ( nextProps.designation.STATUS.CODE === "200" && 
            nextProps.designation.STATUS.MESSAGE === "Successfully Updated Designation" ) {

            message.success('Successfully Updated Designation');
            this.props.get_designation();

            this.setState({
                new_designation_modal: false,
                edit_designation_modal: false,
            })

        } else if ( nextProps.designation.STATUS.CODE === "400" ) {

            message.error( nextProps.designation.STATUS.MESSAGE );
            this.setState({
                new_designation_modal: false,
                edit_designation_modal: false,
            })

        }

        // End

    }


    render() {

        const designation_list = this.state.data.map( (item, i) => <li key={ i } className="list">
            <Dropdown overlay={ <Menu onClick={ this.handleController }>
                <Menu.Item key="1" id={ item.designation_id } ><Icon type="edit" />Edit &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                <Menu.Item key="2" id={ item.designation_id } ><Icon type="delete" />Delete &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                </Menu> } trigger={['click']}>
                <span className="control"><Icon type="ellipsis" /></span>
            </Dropdown>

            <h3>{ item.designation_name }</h3>
            <p>{ item.designation_email }</p>
        </li> )

        return (
            <div className="designation_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="solution" />
                            &nbsp; Designations
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ this.handleNewDesignation }
                            className="fl_right" type="primary" icon="plus">Add Designation</Button>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <ul className="designation_list">
                            { designation_list }
                        </ul>
                    </Col>
                </Row>

                <NewDesignation onSubmit={ this.handleSubmit } onModel={ this.state.new_designation_modal } />
                <EditDesignation onSubmit={ this.handleSubmitEdit } onModel={ this.state.edit_designation_modal } data={ this.state.edit_data } />

            </div>
        )
    }
}


function mapStatetoProps( state ){
    return {
        designation: state.designation
    }
}

export default connect( mapStatetoProps, { save_designation, get_designation, delete_designation, get_designation_by_id, edit_designation} )( Designation );




// WEBPACK FOOTER //
// ./src/pages/designation/index.js